import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class FilesService {
  addFile(bodyParms) {
    let headers = authHeader();
    headers['Content-Type'] = 'multipart/form-data';

    return axios
      .post(`${config["apiUrl"]}file`, bodyParms, {
        headers: headers})
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  removeFile(bodyParms) {
    return axios
      .delete(`${config["apiUrl"]}file`, {
        headers: authHeader(),
        data: bodyParms
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        // if (error.response.status == 401) {
        //   AuthService.logout();
        //   window.location = "/login";
        // }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getFileFromOriginReference(bodyParms) {
    return axios
      .get(`${config["apiUrl"]}file/fromOriginReference`, {
        headers: authHeader(),
        params: bodyParms
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        // if (error.response.status == 401) {
        //   AuthService.logout();
        //   window.location = "/login";
        // }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getSparsFile(filename) {
    return axios
      .get(`${config["apiUrl"]}file/spars/${filename}`, {
        headers: authHeader(),
        responseType: 'blob'
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        console.log("ERROR fetching file:: ", error);
        return null;
    });
  }

  getSparsFamilyFile(filename) {
    const familyFilename = filename.startsWith('families/')
      ? filename.substring('families/'.length)
      : filename;

    return axios
      .get(`${config["apiUrl"]}file/spars/families/${familyFilename}`, {
        headers: authHeader(),
        responseType: 'blob'
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        console.log("ERROR fetching family file:: ", error);
        return null;
      });
  }

  getSparsImportPreview(url) {
    return axios
      .get(url, {
        headers: authHeader(),
        responseType: 'blob'
      })
      .then((response) => response.status == 200 ? response.data : null)
      .catch((error) => {
        console.log("ERROR fetching import preview:: ", error);
        return null;
      });
  }

  getReportsFile(filename) {
    return axios
      .get(`${config["apiUrl"]}file/reports/${filename}`, {
        headers: authHeader(),
        responseType: 'blob'
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        console.log("ERROR fetching file:: ", error);
        return null;
    });
  }

  getStorageFile(filename) {
    return axios
      .get(`${config["apiUrl"]}file/storage?path=${filename}`, {
        headers: authHeader(),
        responseType: 'blob'
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        console.log("ERROR fetching file:: ", error);
        return null;
    });
  }

  scanFileOcr(payload) {
    let headers = authHeader();
    headers["Content-Type"] = "multipart/form-data";

    return axios
      .post(`${config["apiUrl"]}file/scan-ocr`, payload, {
        headers: headers,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response?.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response?.data);
        return null;
      });
  }

  updateDescription(id, description) {
    return axios
      .patch(
        `${config["apiUrl"]}file/description`,
        { id: id, description: description },
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response?.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response?.data);
        return null;
      });
  }
}
export default new FilesService();
